import {
  ApplyNewIcon,
  AppliedIcon,
  DraftIcon,
  ApprovedIcon,
  UsersIcon,
  TotalClaimAppIcon,
  PendingClaimAppIcon,
  ApprovedClaimAppIcon
} from "../icons/UserDashboardIcons";

export const userDashboardCards = [
  {
    title: { en: "Apply New", hi: "नया आवेदन करें" },
    icon: ApplyNewIcon,
    to: "/apply-incentive-claim",
    bgColor: "#e8f0fe",
    bgInnerColor: "#1252EB",
  },
  {
    title: { en: "Apply for Interest Subsidy", hi: "ब्याज सब्सिडी के लिए आवेदन" },
    icon: ApplyNewIcon,
    to: "",
    bgColor: "#e8f0fe",
    bgInnerColor: "#1252EB",
  },
  {
    title: {
      en: "Apply for Capital Incentive Second Installment",
      hi: "पूंजी प्रोत्साहन की दूसरी किस्त का आवेदन",
    },
    icon: ApplyNewIcon,
    to: "",
    bgColor: "#e8f0fe",
    bgInnerColor: "#1252EB",
  },
  {
    title: {
      en: "Apply for Interest Subsidy Second Installment",
      hi: "ब्याज सब्सिडी की दूसरी किस्त का आवेदन",
    },
    icon: ApplyNewIcon,
    to: "",
    bgColor: "#e8f0fe",
    bgInnerColor: "#1252EB",
  },
  {
    title: {
      en: "Apply for Interest Subsidy Third Installment",
      hi: "ब्याज सब्सिडी की तीसरी किस्त का आवेदन",
    },
    icon: ApplyNewIcon,
    to: "",
    bgColor: "#e8f0fe",
    bgInnerColor: "#1252EB",
  },
  {
    title: { en: "Draft", hi: "अधूरा" },
    icon: DraftIcon,
    to: "/draft-applications",
    bgColor: "#FFE4FD",
    bgInnerColor: "#D800C9",
  },
  {
    title: { en: "Applied", hi: "जमा किए गए आवेदन" },
    icon: AppliedIcon,
    to: "/applied-applications",
    bgColor: "#FFDDDD",
    bgInnerColor: "#F00505",
  },
  {
    title: { en: "Approved", hi: "स्वीकृत आवेदन" },
    icon: ApprovedIcon,
    to: "/approved-applications",
    bgColor: "#EDFEFF",
    bgInnerColor: "#018F9B",
  },
];

export const adminDashboardCards = [
  {
    title: { en: "Total Registered Users", hi: "कुल पंजीकृत उपयोगकर्ता" },
    icon: UsersIcon,
    to: "/admin/registered-users",
    bgColor: "#FFE4FD",
    bgInnerColor: "#D800C9",
  },
  {
    title: { en: "Total Claim Applications", hi: "कुल दावा आवेदन" },
    icon: TotalClaimAppIcon,
    to: "/admin/all-applications",
    bgColor: "#E4ECFF",
    bgInnerColor: "#1138aa",
  },
  {
    title: {
      en: "Nodal Pending Applications",
      hi: "नोडल स्तर पर लंबित आवेदन",
    },
    icon: PendingClaimAppIcon,
    to: "/admin/nodal-pending-applications",
    bgColor: "#FFE4E4",
    bgInnerColor: "#DE1616",
  },
  {
    title: {
      en: "Approved Claim Applications",
      hi: "स्वीकृत दावा आवेदन",
    },
    icon: ApprovedClaimAppIcon,
    to: "/admin/approved-applications",
    bgColor: "#EDFEFF",
    bgInnerColor: "#018F9B",
  },
];

export const registeredUsersDashboardCards = [
  {
    title: { en: "Total Registered Users", hi: "कुल पंजीकृत उपयोगकर्ता" },
    icon: UsersIcon,
    to: "/admin/registered-users",
    bgColor: "#FFE4FD",
    bgInnerColor: "#D800C9",
  },
  {
    title: { en: "Pending Users", hi: "लंबित उपयोगकर्ता" },
    icon: PendingClaimAppIcon,
    to: "/admin/applied-applications",
    bgColor: "#FFE4E4",
    bgInnerColor: "#DE1616",
  },
  {
    title: { en: "Approved Users", hi: "स्वीकृत उपयोगकर्ता" },
    icon: ApprovedClaimAppIcon,
    to: "/admin/approved-applications",
    bgColor: "#EDFEFF",
    bgInnerColor: "#018F9B",
  },
];
